import { Alert, Typography, alertClasses, alpha } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Button } from '@/components/Button';
import { IconButton } from '@/components/IconButton';
import { CloseIcon } from '@/components/Icons';
import { useMedia } from '@/hooks/responsive';
import { setOpenReviewAlert } from '@/store/myImages';
import { useIsTrialing } from '@/hooks';
import { REVIEW_PAGE } from './constants';

export function LeaveReviewAlert() {
	const { t } = useTranslation();
	const mdDown = useMedia('mdDown');
	const dispatch = useDispatch();
	const isTrialing = useIsTrialing();

	const handleCloseReviewAlert = () => {
		dispatch(setOpenReviewAlert(false));
		localStorage.setItem('reviewAlertClosed', true);
	};

	if (!isTrialing) {
		return null;
	}

	return (
		<Alert
			action={
				<IconButton
					aria-label="close"
					color="inherit"
					onClick={handleCloseReviewAlert}
					size="small"
				>
					<CloseIcon />
				</IconButton>
			}
			color="info"
			icon={false}
			severity="info"
			sx={theme => ({
				bgcolor: alpha(theme.palette.primary.main, 0.15),
				boxShadow: '0px 2px 4px 0px rgba(161, 130, 243, 0.50)',
				border: `1px solid ${theme.palette.primary.main}`,
				borderRadius: 2,
				justifyContent: 'space-between',
				pl: { xs: 1.5, md: 3.5 },
				py: 0.5,

				[`.${alertClasses.action}`]: {
					alignItems: 'center',
					display: 'flex',
					pt: 0,

					[theme.breakpoints.down('md')]: {
						alignItems: 'start',
						mt: 1
					}
				},

				[`.${alertClasses.message}`]: {
					justifyContent: 'space-between',
					py: 0,
					width: '100%',

					[theme.breakpoints.down('md')]: {
						alignItems: 'start',
						flexDirection: 'column',
						py: 2
					}
				}
			})}
			variant="filled"
		>
			<Typography
				sx={theme => ({
					width: '65%',

					[theme.breakpoints.down('md')]: {
						width: 'auto'
					}
				})}
				variant={mdDown ? 'body0' : 'body1'}
			>
				{t('myImages.leaveReviewAlert.description')}
			</Typography>
			<Button
				sx={theme => ({
					[theme.breakpoints.down('md')]: {
						pb: 0,
						px: 0
					}
				})}
				href={REVIEW_PAGE}
				target="_blank"
				rel="noopener noreferrer"
				onClick={handleCloseReviewAlert}
			>
				{t('myImages.leaveReviewAlert.buttonLabel')}
			</Button>
		</Alert>
	);
}
